/* Translate display labels without changing variant values, IDs, or form submissions. */
(function () {
  "use strict";
  var labels = {"personalizar": "Customize", "no personalizar": "No customization", "sin personalizar": "No customization", "personalización": "Customization", "personalizacion": "Customization", "parches": "Patches", "parche": "Patch", "sin parches": "No patches", "sin parche": "No patch", "ninguno": "None", "pantalón incluido": "Shorts included", "pantalon incluido": "Shorts included", "pantalón": "Shorts", "talla": "Size", "nombre": "Name", "número": "Number", "tipografía": "Font", "liga": "League", "aficionado": "Fan", "jugador": "Player", "infantil": "Kids", "niño": "Kids", "mujer": "Women", "hombre": "Men", "chándal": "Tracksuits", "inicio": "Home", "catálogo": "Catalog", "catálogos": "Catalogs", "colecciones": "Collections", "todos los productos": "All products", "camisetas": "Jerseys", "camisetas de fútbol": "Soccer jerseys", "novedades": "New arrivals", "ofertas": "Offers", "contacto": "Contact", "contáctanos": "Contact us", "nosotros": "About us", "sobre nosotros": "About us", "preguntas frecuentes": "FAQ", "guía de tallas": "Size guide", "tabla de medidas": "Size chart", "rastrear pedido": "Track order", "seguimiento del pedido": "Order tracking", "envíos": "Shipping", "devoluciones": "Returns", "política de privacidad": "Privacy policy", "política de reembolso": "Refund policy", "política de envío": "Shipping policy", "términos y condiciones": "Terms and conditions", "términos del servicio": "Terms of service", "buscar": "Search", "mi cuenta": "My account", "carrito": "Cart", "mundial 2026": "World Cup 2026", "selecciones": "National teams", "equipos": "Teams", "local": "Home", "visitante": "Away", "tercera": "Third", "sí": "Yes", "si": "Yes", "no": "No"};
  window.luxTextEn = function (value) {
    var text = String(value == null ? '' : value);
    var key = text.trim().toLowerCase();
    var translated = labels[key];
    if (!translated) return text;
    return text.trim() === text.trim().toUpperCase() ? translated.toUpperCase() : translated;
  };
})();

/* Apps can insert optional shorts and selected-label text after page load.
   Only presentation text nodes inside product forms are localized. */
(function () {
  'use strict';
  var observedForms = new WeakSet();
  function start() {
    document.querySelectorAll('form.product-form').forEach(function (form) {
      if (observedForms.has(form)) return;
      observedForms.add(form);
      var pending = false;
      function translate() {
        pending = false;
        var walker = document.createTreeWalker(form, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          if (!node.parentElement || node.parentElement.closest('script,style,textarea,option,[contenteditable]')) continue;
          var before = node.nodeValue;
          var after = window.luxTextEn(before);
          after = after.replace(/pantal[oó]n incluido/gi, function (match) {
            return match === match.toUpperCase() ? 'SHORTS INCLUDED' : 'Shorts included';
          });
          if (after !== before) node.nodeValue = after;
        }
      }
      function schedule() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(translate);
      }
      translate();
      new MutationObserver(schedule).observe(form, {childList: true, subtree: true, characterData: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
